import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  loadingOverlay: {
    '& ._loading_overlay_overlay': {
      zIndex: theme.zIndex.appBar + 5,
    },
  },
}));
